import { ChangeDetectionStrategy, Component, ErrorHandler, Input, OnInit, signal } from '@angular/core'

import { Observable, combineLatest, of } from 'rxjs'
import { startWith, switchMap, tap } from 'rxjs/operators'

import {
  LemonaidKirjanpidonRaporttiRequest,
  LemonaidKirjanpidonRaporttiResponse,
  LemonaidRaporttiVirallinenTaseData,
  LemonaidRaporttiVirallinenTaselaskelmarivi,
  RaporttiType,
} from '@lemon/core-firebase/model/reports-shared'
import { Timestamp } from '@lemon/core/model/common'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { RaporttienHakuvaihtoehdot } from './kirjanpidon-raportit.component'

@Component({
  selector: '[app-kirjanpito-virallinen-tase]',
  templateUrl: './virallinen-tase.component.html',
  styleUrls: ['./kirjanpidon-raportit.component.css', './virallinen-tase.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KirjanpidonRaportitVirallinenTaseComponent implements OnInit {
  @Input() hakuvaihtoehdotObservable: Observable<RaporttienHakuvaihtoehdot>

  readonly lastSucessfullyUpdated = signal<Timestamp>(undefined)

  readonly lataa = signal(true)
  virallinenTaseDataObservable: Observable<LemonaidRaporttiVirallinenTaseData>

  constructor(
    private _kayttajaService: KayttajaService,
    private _timestampService: TimestampService,
    private _errorHandler: ErrorHandler,
    private _firebase: FirebaseLemonaid,
    private _translationService: LemonTranslationService,
  ) {}

  ngOnInit() {
    this.virallinenTaseDataObservable = combineLatest([
      this._kayttajaService.kayttajanTiedotObservable,
      this.hakuvaihtoehdotObservable.pipe(
        tap(() => {
          this.lataa.set(true)
        }),
      ),
      this._translationService.currentLanguageObservable,
    ]).pipe(
      switchMap(([kayttaja, hakuvaihtoehdot, kieli]) => {
        if (!hakuvaihtoehdot?.alkaa || !hakuvaihtoehdot?.loppuu || !kayttaja) {
          return of<LemonaidRaporttiVirallinenTaseData>({
            c1Header: null,
            c2Header: null,
            c: 'c2',
            data: [],
          })
        }

        const requestData: LemonaidKirjanpidonRaporttiRequest = {
          a: kayttaja.asiakasAvain,
          k: kieli ?? 'fi',
          w: RaporttiType.TASE_VIRALLINEN,
          s: hakuvaihtoehdot.alkaa,
          e: hakuvaihtoehdot.loppuu,
        }
        return this._firebase
          .functionsCall<LemonaidKirjanpidonRaporttiRequest, LemonaidKirjanpidonRaporttiResponse>('pyydaRaporttiLemonatorista', requestData)
          .then(res => {
            if (res.e) {
              throw new Error(res.e)
            }
            this.lastSucessfullyUpdated.set(this._timestampService.now())
            this.lataa.set(false)
            return res.data
          })
          .catch(err => {
            console.error('Failed to fetch report data', err)
            this._errorHandler.handleError(err)
          })
      }),
      startWith<LemonaidRaporttiVirallinenTaseData>({
        c1Header: null,
        c2Header: null,
        c: 'c2',
        data: [],
      }),
    )
  }

  trackAccountRowByAccountNumberFn(index: number, item: LemonaidRaporttiVirallinenTaselaskelmarivi) {
    return index
  }
}
